import { FC, useState } from "react";
import ButtonUI from "../../../../../components/button/buttons";
import BasicSelect from "../../../../../components/inputs/selectInput";
import useFetchAccountsBank from "../../../../../service/userBankAccount/getUserAccountBank";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Paper,
  SelectChangeEvent,
  Stack,
  TextField,
} from "@mui/material";
import { formatearPesoMXN } from "../../../../../utilis/formatter";
import { CardInfo } from "../../../../../components/common/cardInfo/CardInfo";
import TextIcon from "../../../../../components/TextIcon/TextIcon";
import { AiFillBank } from "react-icons/ai";

export const InfoCard: FC<any> = ({
  setData,
  totalAmount,
  onChange,
  transformData,
}: any) => {
  const storedToken = sessionStorage.getItem("userData");
  const [account, setAccount] = useState<Object>();

  const handleChange = (event: SelectChangeEvent) => {
    setAccount(event.target.value as string);
    setData(event.target.value as string);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        width: "100%",
        maxWidth: "none",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <TextIcon
          title="Solicitar retiro"
          colorIcon="#2865EB"
          colorBackground="#EFF6FF"
          icon={<AiFillBank />}
        />
      </Box>

      <Stack spacing={{ xs: 2.5, sm: 4 }}>
        <TextField
          disabled
          fullWidth
          label="Monto a retirar"
          value={formatearPesoMXN(totalAmount) || 0}
          InputProps={{ readOnly: true }}
        />

        <BasicSelect
          value={account}
          handleChange={handleChange}
          data={transformData ?? []}
          label="Cuenta de retiro"
          labelInput="Cuenta"
          id="select-account"
        />

        <ButtonUI
          onClick={onChange}
          disabled={totalAmount === 0 || account === undefined}
          color="primary"
          fullWidth
          title="Solicitar retiro"
        />
      </Stack>
    </Paper>
  );
};
